import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { ProfileSurvey } from '../../class/profile-survey';

@Injectable()
export class ProfileSurveyService extends WebService {

    public getProfileSurvey(page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('customer_guide.company,profile_survey_new_field.responsabilities.activities'));

        const options = new RequestOptions({ search: params, headers: this.headers });


        return this.http.get(`${this.apiUrl}/profile-surveis?${params}`, options);
    }

    public getProfileSurveyByCustomerGuide(id: number,
        page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }
        params.append('_with', String('customer_guide.company,profile_survey_new_field.responsabilities.activities'));
        const options = new RequestOptions({ search: params, headers: this.headers });


        return this.http.get(`${this.apiUrl}/customer-guides/${id}/profile-surveis?${params}`, options);
    }

    public newProfileSurvey(body: Object): Observable<Response> {
        return this.http.post(`${this.apiUrl}/profile-surveis`, JSON.stringify(body), { headers: this.headers });
    }

    public updateProfileSurvey(id: number, body: Object): Observable<Response> {
        return this.http.patch(`${this.apiUrl}/profile-surveis/${id}`, JSON.stringify(body), { headers: this.headers });
    }

    public deleteProfileSurvey(id: number): Observable<Response> {
        return this.http.delete(`${this.apiUrl}/profile-surveis/${id}`, { headers: this.headers });
    }

    public infoProfileSurvey(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        params.append('_with', String('customer_guide.company,profile_survey_new_field.responsabilities.activities,profile_survey_new_field.competences,medicalExams'));

        const options = new RequestOptions({ search: params, headers: this.headers });

        return this.http.get(`${this.apiUrl}/profile-surveis/${id}?${params}`, options);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/profile-survey/profile-survey.service.ts